import { Plural, Trans, t } from '@lingui/macro';
import { Button, IconButton, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { getMarketByCode } from 'app/domains/markets/config';
import { MetadataApprovers } from './MetadataApprovers';
import { MetadataEntry } from './MetadataEntry';
import { SelectLanguage } from './SelectLanguage';
import { useComposerData } from '../../../ComposerDataProvider';
import { useDraftPreview } from '../../DraftPreviewProvider';
import { Container, Content, Header } from './styled';
export function LeftColumn() {
    const { goBackToSelect } = useComposerData();
    const { locked, estimatedTime, marketCode, createDraft } = useDraftPreview();
    const market = getMarketByCode(marketCode);
    return (<Container>
      <Header>
        <IconButton $round appearance="ghost" onClick={goBackToSelect}>
          <Falcon icon="chevron-left"/>
        </IconButton>
        <Typography $appearance="300" $fontSize="large" $fontWeight="semibold">
          <Trans comment="Preview template - Go back to view all templates">View all</Trans>
        </Typography>
      </Header>
      <Content>
        <Button disabled={locked} onClick={createDraft}>
          {locked && <Falcon icon="lock"/>}
          <Trans comment="Preview template - Create document from template label">
            Create document
          </Trans>
        </Button>
        <MetadataEntry label={t({
            comment: 'Preview template - Language label',
            message: 'Language',
        })} component={<SelectLanguage />}/>
        {estimatedTime !== undefined && (<MetadataEntry label={t({
                comment: 'Preview template - Estimated time label',
                message: 'Estimated time',
            })} component={<Plural value={estimatedTime} one="# minute" other="# minutes"/>}/>)}
        <MetadataEntry label={t({ comment: 'Preview template - Approvers label', message: 'Approvers' })} component={<MetadataApprovers />}/>
        <MetadataEntry label={t({ comment: 'Preview template - Jurisdiction label', message: 'Jurisdiction' })} component={market.getName()}/>
      </Content>
    </Container>);
}
